var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoothTypeUnsure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 214,
    viewBox: "0 0 300 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.740234 86.6197L150 172.33L299.26 86.6197L150 0.909668L0.740234 86.6197Z",
    fill: "#E2F5FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3604 86.6199L150 38.5898L233.64 86.6199L150 134.65L66.3604 86.6199Z",
    fill: "#E2F5FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3496 86.6198L150 36.8598V36.8198L236.65 86.6198L150 136.38L63.3496 86.6198Z",
    fill: "#B4E5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164 81.5C164 83.433 157.732 85 150 85C142.268 85 136 83.433 136 81.5C136 79.567 142.268 78 150 78C157.732 78 164 79.567 164 81.5Z",
    fill: "#84D4F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.474 56.838H151.125V53.2947C151.125 42.4176 166 41.264 166 27.5852C166 19.0154 158.853 13 149.38 13C141.152 13 136 17.6969 136 17.6969L139.075 21.8994C139.075 21.8994 143.479 18.3561 149.13 18.3561C155.529 18.3561 160.017 22.5587 160.017 27.8324C160.017 38.4623 145.474 40.0279 145.474 53.1299V56.838ZM145.141 72H151.54V65.655H145.141V72Z",
    fill: "#1E73BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoothTypeUnsure);
export default __webpack_public_path__ + "static/media/booth-type-unsure.0efa519cf7d21b8fdc0a4e9489951c1f.svg";
export { ForwardRef as ReactComponent };